export default __webpack_public_path__ + "static/media/RedHatDisplay-Medium.ada84716.woff";